var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('h6',{staticClass:"text-uppercase font-size-base text-muted mt-2 border-bottom pb-4 text-center"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"pt-1"},[_c('div',{staticClass:"navi navi-hover navi-active navi-accent navi-link-rounded font-size-lg font-weight-bold"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }